import { render, staticRenderFns } from "./HonobonoInlineFrame.vue?vue&type=template&id=3791cc90&"
import script from "./HonobonoInlineFrame.vue?vue&type=script&lang=ts&"
export * from "./HonobonoInlineFrame.vue?vue&type=script&lang=ts&"
import style0 from "./HonobonoInlineFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports